<template>
  <div>
    <div class="jns-loading-indicator" v-if="loadingIndicatorFlag">
      <v-progress-circular
        indeterminate
        v-bind:size="50"
        color="primary"
      ></v-progress-circular>
    </div>

    <v-dialog v-model="errorModalFlag" persistent :max-width="'640'">
      <v-card>
        <v-card-title>
          <h2 class="title" v-html="errorModal.title"></h2>
        </v-card-title>

        <v-card-text class="login-modal">
          <p class="description" v-html="errorModal.message"></p>
          <span v-if="errorModal.html" v-html="errorModal.html"></span>
          <div
            v-if="errorModal.image && errorModal.image.src"
            class="img-content"
          >
            <span :class="errorModal.image.class" />
            <img :src="imageSrc" />
          </div>
          <span
            v-if="errorModal.image && errorModal.image.descricao"
            v-html="errorModal.image.descricao"
          ></span>

          <v-layout row wrap v-if="errorModal.details != 'Sem detalhes'">
            <v-flex xs4>
              <p class="see-details mb-0" @click="toggleShowDetails()">
                Ver detalhes
                <v-btn icon>
                  <v-icon v-if="showDetails">keyboard_arrow_up</v-icon>
                  <v-icon v-if="!showDetails">keyboard_arrow_down</v-icon>
                </v-btn>
              </p>
            </v-flex>
            <v-fade-transition>
              <v-flex xs12 v-if="showDetails">
                <v-textarea
                  class="details"
                  outline
                  readonly
                  :value="errorModal.details"
                ></v-textarea>
              </v-flex>
            </v-fade-transition>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-layout row wrap>
            <v-flex
              xs8
              v-if="
                errorModal.dontAskMeAgainCookie &&
                errorModal.dontAskMeAgainCookie.message
              "
            >
              <v-checkbox
                mt-0
                v-model="checkValue"
                :label="errorModal.dontAskMeAgainCookie.message"
              ></v-checkbox>
            </v-flex>
            <v-flex
              xs4
              :class="
                errorModal.dontAskMeAgainCookie &&
                errorModal.dontAskMeAgainCookie.message
                  ? ''
                  : 'offset-xs8'
              "
            >
              <button
                class="button jns-button yellow-button"
                @click="callback()"
              >
                OK
              </button>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingAskWaitModal" persistent :max-width="'420'">
      <base-modal>
        <img
          :src="require('../assets/animations/loading-yellow.gif')"
          class="loading-animation"
          alt
        />
        <h2 class="title text-xs-center">Aguarde</h2>
        <p class="description text-xs-center mt-3">
          Os dados estão sendo buscados, o processo pode demorar um pouco.
        </p>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "ModalHelpers",
  mixins: [ViewMixin],
  data() {
    return {
      checkValue: false,
      showDetails: false,
    };
  },
  computed: {
    loadingIndicatorFlag() {
      return this.$store.state.main.loadingIndicatorFlag;
    },
    errorModal() {
      return this.$store.state.main.errorModal;
    },
    errorModalFlag() {
      return this.$store.state.main.errorModalFlag;
    },
    loadingAskWaitModal() {
      return this.$store.state.main.loadingAskWaitFlag;
    },
    imageSrc() {
      var images = require.context("../assets/", false, /\.png$/);
      return images(`./${this.errorModal.image.src}`);
    },
  },
  methods: {
    toggleShowDetails() {
      this.showDetails = !this.showDetails;
    },

    callback() {
      this.errorModal.callback();
      if (this.errorModal.dontAskMeAgainCookie && this.checkValue) {
        this.checkValue = false;
        this.errorModal.dontAskMeAgainCookie.action();
      }

      this.showDetails = false;
      this.hideErrorModal();
    },
  },
};
</script>

<style lang="css" scoped>
img {
  width: 100%;
}

.seta {
  z-index: 999;
  display: block;
  position: absolute;
  border-left: 100px solid #f1e41e;
  border-top: 183px solid transparent;
  border-bottom: 183px solid transparent;
}

.v-card__text {
  overflow: auto !important;
  max-height: 70vh;
}

.v-input--selection-controls {
  margin-top: 6px !important;
}

.v-card {
  padding: 30px 30px 0 30px;
}

.img-content {
  display: block;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalHelpers.vue